module.exports = __webpack_public_path__ + "static/media/step3.942db836.png";